function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "#707071",
  points: "18.3,7.7 18.3,5.7 14.8,5.7 13.8,4.7 9.2,4.7 12.1,7.7    "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#707071",
  points: "17.3,8.7 13.1,8.7 17.3,13  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707071",
  d: "M17.3,15.7l-6.8-7l-1-1l-1.9-2L3.3,1.3L1.9,2.7l2.9,3H4.3v2h2.4l1,1H5.3v12c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2v-2.1             l3.4,3.5l1.4-1.4L17.3,15.7z"
}));

function SvgIconDisabledDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default __webpack_public_path__ + "f2296fc55b7536acfd390f501f45ec01.svg";
export { SvgIconDisabledDelete as ReactComponent };